import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Post from '../Post';

export default class PostList extends React.Component
{
    static propTypes = {
        posts: PropTypes.array.isRequired,
        integrations: PropTypes.array,
        status: PropTypes.string,
    };

    static defaultProps = {
        integrations: [],
        status: 'draft'
    };

    render()
    {
        if (this.props.posts.length < 1) {
            return null;
        }

        const orderedPosts = this.sortPostsByDate(this.props.posts);

        const groupedPosts = this.groupPosts(orderedPosts);

        return <div className="space-y-4">
            {
                _.map(groupedPosts, group => <div key={group.title}>

                    <h1 className='text-xl mt-8 mb-4'>{group.title}</h1>

                    <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6'>
                        {
                            _.map(group.posts, post => <div>{ this.renderPost(post) }</div>)
                        }
                    </div>

                </div>)
            }
        </div>;
    }

    renderPost(post)
    {
        const integration = this.getIntegrationById(post.integration_id);

        return <Post key={post.id} post={post} integration={integration} />;
    }

    getIntegrationById(id)
    {
        return _.find(this.props.integrations, integration => integration.id === id);
    }

    groupPosts(posts)
    {
        if (this.props.status === 'draft') {
            return [{
                title: null,
                posts: posts
            }];
        }

        const key = this.getSortKey();

        // this gives an object with dates as keys
        const groups = posts.reduce((groups, post) => {
            const date = new Date(post[key]).toISOString().split('T')[0];

            if ( ! groups[date]) {
                groups[date] = [];
            }

            groups[date].push(post);

            return groups;
        }, {});

        const options = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };

        // Edit: to add it in the array format instead
        return Object.keys(groups).map((date) => ({
            title: new Date(date).toLocaleDateString("en-US", options),
            posts: groups[date]
        }));
    }

    sortPostsByDate(posts)
    {
        return _.orderBy(posts, this.getSortKey(), this.getSortOrder());
    }

    getSortKey()
    {
        switch (this.props.status)
        {
            case 'shared':
                return 'published_at';
            case 'scheduled':
                return 'scheduled_for';
            case 'draft':
                return 'created_at';
            default:
                return 'created_at';
        }
    }

    getSortOrder()
    {
        switch (this.props.status)
        {
            case 'shared':
            case 'draft':
                return 'desc';
            default:
                return 'asc';
        }
    }
}
